module.exports = __webpack_public_path__ + "img/consultoria_16-9_2880.1f2351ad.jpg";